<template>
  <div class="container">
    <div class="calendar">
      <ele-calendar :render-content="renderContent" :data="datedef" :prop="prop" value-format="yyyy-MM-dd" :border="true" @pick="clickpick" />
      <div v-if="rightbox" class="rightbox_buttom">
        <div class="rightboxbottom">
          <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="68px" class="demo-ruleForm">
            <el-form-item :label="$t('fleet.Typeofoperation')">
              <el-radio-group v-model="ruleForm.data.type">
                <el-radio label="1">{{ $t('fleet.increase') }}</el-radio>
                <el-radio label="-1">{{ $t('fleet.reduce') }}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item :label="$t('hotel.Stock')" prop="data.stock">
              <el-input v-model.number="ruleForm.data.stock" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">{{ $t('hotel.immediatesubmission') }}</el-button>
              <el-button @click="resetForm('ruleForm')">{{ $t('hotel.reset') }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div class="rightbox">
      <template v-if="date[0]">
        <div v-for="(item,index) in date" :key="index" :class="!rightbox?'datatime noPadding':'datatime'">
          {{ item.time }} <div :class="item.stock>0?'green':'red'">{{ $t('hotel.surplus') }} {{ item.stock }} {{ $t('hotel.room') }}</div>
          <span v-if="rightbox">{{ $t('hotel.reserve') }} {{ item.reserved }} {{ $t('hotel.room') }}</span>
        </div>
      </template>
      <template v-else>
        <div class="nodata">
          <img src="../../../assets/nodata.png" alt="no data">
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import eleCalendar from 'ele-calendar'
import 'ele-calendar/dist/vue-calendar.css'
import { getStock, setStock } from '@/api/hotel'
// import { getToken } from '@/utils/auth'

export default {
  components: {
    eleCalendar
  },
  props: {
    rightbox: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      datedef: [],
      prop: 'date', // 对应日期字段名
      datas: {
        data: {
          hotel_id: '2',
          room_id: '3',
          date: ''
        },
        client_type: 'pc'
      },
      date: [],
      ruleForm: {
        client_type: 'pc',
        data: {
          room_id: '3',
          stock: '',
          type: '1',
          date: ''
        }
      },
      rules: {
        data: {
          stock: [
            { required: true, message: '请输入库存', trigger: 'blur' },
            { type: 'number', message: '只能输入数字', trigger: 'blur' }
          ]
        }
      }
    }
  },
  mounted() {
    this.thisTime()
    this.getList()
  },
  methods: {
    /* 提交按钮 */
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const that = this
          /* 修改库存 */
          if (formName === 'ruleForm') {
            // console.log(this.ruleForm)
            setStock(this.ruleForm)
              .then(res => {
                that.getList()
                that.resetForm(formName)
                that.$message({
                  type: 'success',
                  message: res.message
                })
              })
              .catch(() => {
                // console.log(111)
              })
          }
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    /* 重置按钮 */
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    getList() {
      const that = this
      // console.log(this.datas)
      getStock(this.datas)
        .then(res => {
          // console.log(res)
          that.date = res.data
        })
        .catch(() => {
          // console.log(111)
        })
    },
    /* 获取当前选中的时间 */
    clickpick(val, selectDom) {
      this.datas.data.date = val
      this.ruleForm.data.date = val
      this.getList()
    },
    /* 获取默认时间 */
    thisTime() {
      const date = new Date()
      const seperator1 = '-'
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      let strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      const currentdate = year + seperator1 + month + seperator1 + strDate
      // console.log(currentdate)
      this.datas.data.date = currentdate
    },
    renderContent(h, parmas) {
      const loop = data => {
        return data.defvalue.value ? (
          <div>
            <div>{data.defvalue.text}</div>
            <span>剩余{data.defvalue.value.content}间</span>
          </div>
        ) : (
          <div>{data.defvalue.text}</div>
        )
      }
      return <div style='min-height:30px'>{loop(parmas)}</div>
    }
  }
}
</script>

<style scoped>
.container {
  margin: 0;
  display: flex;
  /* overflow: auto; */
  flex-wrap: wrap;
}
.calendar {
  width: 288px;
  min-width: 288px;
  margin-right: 12px;
  margin-bottom: 12px;
  overflow: auto;
}
.rightbox {
  /* width: 802px;
	min-width: 288px; */
  border-top: 1px solid #e4e7ed;
  border-left: 1px solid #e4e7ed;
  flex: 1;
  text-align: center;
  color: #606266;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.1);
  margin-right: 5px;
}
.datatime {
  width: 25%;
  display: inline-block;
  border: 1px solid #e4e7ed;
  border-left: 0px;
  border-top: 0px;
  line-height: 1.4;
  font-size: 0.8em;
  padding: 10px;
}
.datatime span {
  display: inline-block;
}
.noPadding {
  padding: 5px 0;
}
.green {
  color: #67c23a;
}
.red {
  color: #f56c6c;
}
.rightbox_buttom {
  margin-top: 28px;
  padding-top: 44px;
  border: 1px solid #e4e7ed;
}
.rightboxbottom > p {
  text-align: center;
  line-height: 44px;
  color: rgb(102, 102, 102);
}
.demo-ruleForm {
  width: 90%;
  margin: auto;
}
.nodata {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.nodata img {
  width: 50%;
  max-width: 480px;
  display: block;
}
</style>
